import { gql } from '@apollo/client';
import { ENROLLMENT_COURSE_FIELDS } from "./course";
export const ENROLLMENT_SUBTRAINING_PROGRAM_FIELDS = gql`
  ${ENROLLMENT_COURSE_FIELDS}
  fragment EnrollmentSubtrainingProgramFields on PortalEnrollmentSubtrainingProgramDTO {
    id
    name
    parentId
    order
    enrollmentCourses {
      ...EnrollmentCourseDTO
    }
  }
`;